import ManageFaqText from './ManageFaqText.component';

export default ManageFaqText;